window.tawk.onLoad = function () {
  tawkActions()
}

window.tawk.onChatMinimized = function () {
  minimize()
}

function tawkActions() {
  window.tawk.minimize()
  window.tawk.hideWidget()
  $(".tawk-btn").addClass("show")
  $(".tawk-btn").on("click", function () {
    if (window.tawk.isChatMaximized()) {
      minimize()
    } else {
      maximize()
    }
  })
}

function maximize() {
  window.tawk.showWidget()
  window.tawk.maximize()
  $(".tawk-btn").addClass("maximized")
}

function minimize() {
  window.tawk.minimize()
  window.tawk.hideWidget()
  $(".tawk-btn").removeClass("maximized")
}
